import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, CanActivateFn, Router } from '@angular/router';
import { LoginServicesService } from '../services/login-services.service';


@Injectable({
  providedIn: 'root'
})


export class Balance implements CanActivate {
  data:any;
  constructor(private authService: LoginServicesService, private router: Router,private activatedRoute: ActivatedRoute) {}

  canActivate(): boolean {
    this.data =JSON.parse(localStorage.getItem('data')!); 
    

    if (this.data.CanGenerateBalanceReporte>0) {
      return true;
    } else {
      this.router.navigate(['app/dashboard']);
      return false;
    }
  }
}